// extracted by mini-css-extract-plugin
module.exports = {"comments":"CommentsList_comments__BgxpX"};